import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { NumberConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
import { SliderMode } from './slider-types';
var SliderComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SliderComponent, _super);
    function SliderComponent(_vcr, cdr) {
        var _this = _super.call(this, _vcr) || this;
        _this.cdr = cdr;
        _this._description = '';
        _this._gap = 0;
        _this._minValue = 0;
        _this._mode = SliderMode.Single;
        _this.valueChange = new EventEmitter();
        return _this;
    }
    Object.defineProperty(SliderComponent.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (value) {
            this._description = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "field", {
        get: function () {
            return this._field;
        },
        set: function (value) {
            this._field = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "gap", {
        get: function () {
            return this._gap;
        },
        set: function (value) {
            this._gap = NumberConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "max", {
        get: function () {
            return this._max;
        },
        set: function (value) {
            this._max = NumberConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "maxValue", {
        get: function () {
            return this._maxValue;
        },
        set: function (value) {
            this._maxValue = NumberConverter(value);
            this.onMinMaxValueChange(false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "min", {
        get: function () {
            return this._min;
        },
        set: function (value) {
            this._min = NumberConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "minValue", {
        get: function () {
            return this._minValue;
        },
        set: function (value) {
            this._minValue = NumberConverter(value);
            this.onMinMaxValueChange(true);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "mode", {
        get: function () {
            return this._mode;
        },
        set: function (value) {
            this._mode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "step", {
        get: function () {
            return this._step;
        },
        set: function (value) {
            this._step = NumberConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "value", {
        get: function () {
            return this.maxValue;
        },
        set: function (value) {
            this.maxValue = NumberConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "slider", {
        set: function (elementRef) {
            if (elementRef && !this.sliderRef) {
                this.sliderRef = elementRef;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "sliderMax", {
        set: function (elementRef) {
            if (elementRef && !this.sliderMaxRef) {
                this.sliderMaxRef = elementRef;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SliderComponent.prototype, "sliderMin", {
        set: function (elementRef) {
            if (elementRef && !this.sliderMinRef) {
                this.sliderMinRef = elementRef;
            }
        },
        enumerable: true,
        configurable: true
    });
    SliderComponent.prototype.ngOnInit = function () {
        try {
            this.registerEvent('valueChange', this.valueChange);
            this.setSliderDisplay();
        }
        catch (error) {
            this.readyProblem(error);
        }
        finally {
            this.isReady();
        }
    };
    SliderComponent.prototype.onMinMaxValueChange = function (isMinValue) {
        if (this.minValue != null && this.maxValue != null) {
            if (this.maxValue > this.max) {
                this.maxValue = this.max;
            }
            if (this.minValue < this.min) {
                this.minValue = this.min;
            }
            if (this.maxValue - this.minValue < this.gap) {
                if (isMinValue) {
                    this.minValue = this.maxValue - this.gap;
                    this.sliderMinRef.nativeElement.value = this.minValue.toString(); // Needed to enforce slider not moving past max
                }
                else {
                    this.maxValue = this.minValue + this.gap;
                    this.sliderMaxRef.nativeElement.value = this.maxValue.toString(); // Needed to enforce slider not moving past min
                }
            }
            this.cdr.detectChanges();
            this.setSliderDisplay();
            if (this.mode === SliderMode.Multiple) {
                this.valueChange.emit({ minValue: this.minValue, maxValue: this.maxValue });
            }
            else {
                this.valueChange.emit({ value: this.maxValue });
            }
        }
    };
    SliderComponent.prototype.setSliderDisplay = function () {
        if (this.sliderRef && this.max && this.minValue != null && this.maxValue != null) {
            this.sliderRef.nativeElement.style.left = this.mode === SliderMode.Multiple
                ? Math.max((this.minValue / this.max) * 100, 1) + "%"
                : '0';
            this.sliderRef.nativeElement.style.right = Math.max(100 - (this.maxValue / this.max) * 100, 1) + "%";
        }
    };
    return SliderComponent;
}(BaseComponent));
export { SliderComponent };
